import cn from 'classnames';
import { useContext } from 'react';

import Button from 'components/common/Button';
import Text from 'components/common/Text';
import Divider from 'components/icons/Divider';
import DiscountTag from 'components/icons/illustrative/DiscountTag';
import { BrandContext, HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import { ICON_SIZES } from 'lib/constants/iconSizes';
import styles from 'styles/components/signUpFunnel/promo/PromoCodeSection';

import PromoCodeForm from './PromoCodeForm';

const PromoCodeSection = ({
  errorMessage = '',
  handleAddVoucherClick,
  handleSecretSaleClick,
  isSubmitting,
}) => {
  const { brand } = useContext(BrandContext);
  const isHomeChef = useBrand(HOME_CHEF);

  return (
    <div>
      <section
        className={cn(
          'mx-auto mb-6 rounded-3xl px-4 py-6 bp1:w-full',
          styles.background,
          styles[brand]
        )}
      >
        <div className="flex items-center justify-center">
          <DiscountTag svgSize={ICON_SIZES.MD} className="mr-1" />
          <Text brandStylesOverrides="h2 text-primary" className="mb-2 mt-2">
            Get $10 off!
          </Text>
        </div>
        <Text brandStylesOverrides="" className="pb-3 text-center">
          Sign up for {isHomeChef ? 'Home Chef' : 'Tempo'} today to get $10 off your second order.
          Offer expires in 90 days from sign up date.
        </Text>
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex w-full justify-center">
            <Button
              type="button"
              onClick={handleSecretSaleClick}
              className="textSm w-full p-2 bp1:w-96"
              variation="Pill"
            >
              Get $10 Off Your Second Order
            </Button>
          </div>
          <div className="flex flex-col items-center text-center">
            <Divider />
            <Text className="mb-2 pt-4" brandStylesOverrides="textSm text-secondary">
              Use a Different Promo Code or Gift Card
            </Text>
            <PromoCodeForm
              handleAddVoucherClick={handleAddVoucherClick}
              errorMessage={errorMessage}
              isSubmitting={isSubmitting}
              buttonClassName="btnOutlineSecondary"
              formFieldClassName="justify-center"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

PromoCodeSection.propTypes = {
  errorMessage: PropTypes.string,
  handleAddVoucherClick: PropTypes.func.isRequired,
  handleSecretSaleClick: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default PromoCodeSection;
